import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

function FloatingWhatsApp() {
  const phoneNumber = "32460940222";
  const message = encodeURIComponent("Hallo! Ik heb een vraag over uw renovatiediensten.");
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-white px-4 py-3 rounded-full shadow-lg hover:bg-[#1ebe5d] transition-all duration-300 hover:scale-105 group whitespace-nowrap"
      aria-label="Contact via WhatsApp"
    >
      <div className="w-6 h-6 flex items-center justify-center">
        <i className="ri-whatsapp-line text-xl leading-none"></i>
      </div>
      <span className="text-sm font-medium max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-300 ease-in-out">
        WhatsApp
      </span>
    </a>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <FloatingWhatsApp />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
